import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FiltersModule } from '../filters/filters.module';
import { JwtInterceptor } from '../helpers/jwt.interceptor';
import { UserService } from '../services/identity/user.service';
import { ImageService } from '../services/shared/image.service';
import { SharedModule } from '../shared/shared.module';
import { FeedComponent } from './components/feed/feed.component';
import { OnboardingCommunityMembersComponent } from './components/onboarding-community-members/onboarding-community-members.component';
import { OnboardingUserCompletionComponent } from './components/onboarding-user-completion/onboarding-user-completion.component';
import { OnboardingUserInfosComponent } from './components/onboarding-user-infos/onboarding-user-infos.component';
import { OnboardingUserInterestsComponent } from './components/onboarding-user-interests/onboarding-user-interests.component';
import { OnboardingUserSkillsComponent } from './components/onboarding-user-skills/onboarding-user-skills.component';
import { WallComponent } from './components/wall/wall.component';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import { HelpPageComponent } from './pages/help-page/help-page.component';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { OnboardingPageComponent } from './pages/onboarding-page/onboarding-page.component';
import { ExternalLinksPageComponent } from './pages/external-links-page/external-links-page.component';

@NgModule({
    declarations: [
        HomeComponent,
        HomePageComponent,
        ContactUsComponent,
        FeedComponent,
        HelpPageComponent,
        ExternalLinksPageComponent,
        WallComponent,
        OnboardingPageComponent,
        OnboardingUserInfosComponent,
        OnboardingUserSkillsComponent,
        OnboardingUserInterestsComponent,
        OnboardingUserCompletionComponent,
        OnboardingCommunityMembersComponent,
    ],
    imports: [CommonModule, HttpClientModule, HomeRoutingModule, FiltersModule, SharedModule, FormsModule, ReactiveFormsModule],
    providers: [UserService, ImageService, { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }],
})
export class HomeModule {}
